import React, { useState } from "react";
import "./index.css";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { toast_position } from "../../../redux/features/Settings/Authorization";
import { disabledEnabledError } from "../../../redux/features/totp/totp";
import { useDispatch } from "react-redux";

const TotpStepper = ({
  activeStep,
  handleBack,
  steps,
  handleNext,
  nextButtonEnabled,
  direction,
  setCurrentDisplay,
  backupCodes,
}) => {
  const [disabled, setDisabled] = useState(false);
  const dispatch = useDispatch();
  const downloadTxtFile = () => {
    const formattedText = backupCodes.join("\n");
    const blob = new Blob([formattedText], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "backupCodes.txt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
  const handleTotp = async () => {
    dispatch(disabledEnabledError());
    setDisabled(true);
    downloadTxtFile();
    setCurrentDisplay("disabled");
    toast.success("TOTP setup completed successfully", toast_position);
    setTimeout(() => {
      setDisabled(false);
    }, 1000);
  };

  return (
    <div className="internal-stepper-main">
      <Button
        className={`custom_create_totp ${
          activeStep === 0 ? "inactive" : "active"
        }`}
        style={{
          backgroundColor: "var(--Blue_7)",
          color: "var(--Primary_white)",
        }}
        sx={{ borderRadius: 0 }}
        onClick={handleBack}
      >
        {activeStep === 0 ? "Cancel" : "Previous"}
      </Button>
      <div className="internal-stepperline_Div_biller">
        {steps?.map((val, index) => {
          return (
            <div className="stepinnerline" key={index}>
              <div
                className={`stepDetails ${
                  activeStep !== index ||
                  (activeStep === 0 && direction === "next")
                    ? ""
                    : "growing-element"
                }`}
                style={{
                  opacity: activeStep === index ? "1" : "0",
                }}
              >
                {activeStep === index ? val : "Hello"}
              </div>
              <div
                className={`internal-main_Line ${
                  activeStep !== index ||
                  (activeStep === 0 && direction === "next")
                    ? ""
                    : "growing-element"
                }`}
                style={{
                  width: activeStep === index ? "220px" : "100px",
                  opacity: activeStep === index ? "1" : "0.5",
                }}
              ></div>
            </div>
          );
        })}
      </div>
      {activeStep === 3 ? (
        <Button
          className={`create_Button ${
            activeStep === 3 ? "active" : "inactive"
          }`}
          onClick={handleTotp}
          sx={{ borderRadius: 0 }}
          disabled={disabled}
        >
          Download
        </Button>
      ) : (
        <Button
          disabled={!nextButtonEnabled}
          className={`custom_create_next_stepper ${
            !nextButtonEnabled ? "inactive" : "active"
          }`}
          style={{
            backgroundColor: !nextButtonEnabled
              ? "var(--Secondary_grey)"
              : "var(--Primary_white)",
            color: !nextButtonEnabled
              ? "var(--Primary_white)"
              : "var(--Blue_3)",
            fontWeight: !nextButtonEnabled
              ? "var(--Font_normal)"
              : "var(--Font_semibold)",
          }}
          sx={{ borderRadius: 0 }}
          onClick={handleNext}
        >
          Next
        </Button>
      )}
    </div>
  );
};

export default TotpStepper;
